import { List } from 'immutable';
import { useEffect, useState } from 'react';
import { atomToPromise } from '../../../utils/atomToPromise';
import { isFieldRestricted } from '../../../utils/fieldLevelPermissions';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import { sortTeamsAlphabetically } from 'ui-addon-teams/lib/teams';
import { useQuickFilterResolverAndOptions } from '../../../hooks/useQuickFilterResolverAndOptions';
import unescapedText from 'I18n/utils/unescapedText';
import Raven from 'raven-js';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import Team from 'ui-addon-teams/records/Team';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
const getTeamOptions = teams => {
  return teams.toArray().map(team => {
    const teamOption = {
      text: team.name,
      value: String(team.id)
    };
    if (team.childTeams.size) {
      const selectAllOption = {
        text: unescapedText('customerDataFiltersUI.quickFiltersBar.team.selectAll', {
          teamName: team.name
        }),
        selectAll: true,
        options: List.of(teamOption).concat(getTeamOptions(team.childTeams)).toJS()
      };
      return selectAllOption;
    }
    return teamOption;
  });
};
const getOptions = (teams, customOptions) => {
  const teamOptions = getTeamOptions(sortTeamsAlphabetically(teams.map(Team.fromReference)));
  return customOptions.concat(teamOptions);
};
const TeamQuickFilterButton = ({
  ButtonContent,
  buttonProperties,
  dropdownFooter,
  filterFamily,
  isOptionsSelectDisabled,
  placement,
  property,
  value,
  onChange
}) => {
  const isRestrictedField = isFieldRestricted(property.accessLevel);
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [teams, setTeams] = useState(List());
  const {
    resolver,
    options
  } = useQuickFilterResolverAndOptions(filterFamily, isOptionsSelectDisabled, property);
  useEffect(() => {
    const canFetch = resolver && 'all' in resolver && typeof resolver.all === 'function';
    if (!canFetch) {
      Raven.captureException(new Error(`[Expected a reference resolver] resolver for Team Quick Filter does not have 'all' function`));
      return;
    }
    atomToPromise(resolver.all()).then(result => {
      const teamsResult = result;
      setTeams(teamsResult.toList());
    }).finally(() => setIsLoading(false));
  }, [resolver]);
  const onOpenChange = evt => {
    setOpen(evt.target.value);
  };
  return /*#__PURE__*/_jsx(Select, {
    anchorType: "button",
    ButtonContent: ButtonContent,
    buttonSize: buttonProperties.BUTTON_SIZE,
    buttonUse: buttonProperties.BUTTON_USE,
    disabled: isRestrictedField || property.disabled,
    dropdownFooter: dropdownFooter,
    isLoading: isLoading,
    menuWidth: "auto",
    multi: true,
    onChange: onChange,
    onOpenChange: onOpenChange,
    open: open,
    options: getOptions(teams, options),
    placeholder: unescapedText('customerDataFiltersUI.quickFiltersBar.team.selectTeams'),
    placement: placement,
    value: value
  });
};
export default TeamQuickFilterButton;